export interface ObjectStorage {
    id: string;
    name: string;
    type: ObjectStorageType,
}

export enum ObjectStorageType{
  Menu = 'Menu',
  KeyValue = 'KeyValue',
  SpecialInstruction = 'SpecialInstruction',
  StopList = 'StopList',
  DerivativeResult = 'DerivativeResult',
  Product = 'Product',
  ErrorResult = 'ErrorResult',
}
